export default [
  {
    header: 'Cuenta de usuario',
    action: 'read',
    resource: 'ACL',
  },
  {
    title: 'Perfil',
    route: 'profile',
    icon: 'UserIcon',
    action: 'read',
    resource: 'ACL',
  },
  {
    title: 'Cerrar sesión',
    route: 'logout',
    icon: 'LogOutIcon',
    action: 'read',
    resource: 'ACL',
  },
]
